/**
 * Smatchy
 * The smatchy API description. Use POST /auth/login to get an access token.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { GeoLocationEntity } from './geoLocationEntity';

export interface EditGroupDto {
  /**
   * Allow activities to invite this group as a share target.
   */
  allowActivitySharing?: boolean;
  handiFriendly?: boolean;
  name?: string;
  backgroundUrl?: string;
  /**
   * The group's own square mark, distinct from backgroundUrl above. Added by
   * hand like sportIds below, and for the same reason: `generate:sdk` needs a
   * running API and the offline export does not carry this model. An empty
   * string removes the logo; the API reads it as « clear ».
   */
  logoUrl?: string;
  websiteUrl?: string;
  privacy?: EditGroupDto.PrivacyEnum;
  description?: string;
  location?: GeoLocationEntity;
  sportId?: string;
  /**
   * SMA-99. Added by hand like the other two: `generate:sdk` needs a running
   * API, and the offline export does not carry this model.
   */
  sportIds?: Array<string>;
  rightCreateActivity?: EditGroupDto.RightCreateActivityEnum;
}
export namespace EditGroupDto {
  export type PrivacyEnum = 'public' | 'private' | 'hidden';
  export const PrivacyEnum = {
    Public: 'public' as PrivacyEnum,
    Private: 'private' as PrivacyEnum,
    Hidden: 'hidden' as PrivacyEnum,
  };
  export type RightCreateActivityEnum = 'allMembers' | 'onlyAdmin';
  export const RightCreateActivityEnum = {
    AllMembers: 'allMembers' as RightCreateActivityEnum,
    OnlyAdmin: 'onlyAdmin' as RightCreateActivityEnum,
  };
}
